import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';
import {debounceTime, takeUntil} from 'rxjs/operators';
import {RootService} from '../../services';
import {AgentService} from '../../services/business/agent/agent.service';
import {getDateHelper} from '../../shared/common/helper';
import {removeEmptyQuery} from '../../helpers';
import * as _ from "lodash";
import {PopupAcceptAgentComponent} from './popup/popup-accept-agent/popup-accept-agent.component';
import {NzModalService, NzNotificationService} from 'ng-zorro-antd';

@Component({
  selector: 'app-agent-ctv',
  templateUrl: './agent-ctv.component.html',
  styleUrls: ['./agent-ctv.component.scss']
})

export class AgentCtvComponent implements OnInit {
  formAgent: FormGroup;
  dateFormat = 'dd/MM/yyyy';
  cities = [];
  status = [
    {
      name: 'Chờ duyệt',
      value: '0'
    },
    {
      name: 'Đã duyệt',
      value: '1'
    },
    {
      name: 'Từ chối',
      value: '2'
    }
  ];
  listOfAllData: any[] = [];
  listOfDisplayData: any[] = [];
  total: number;
  loading = true;
  page = 1;
  pageSize = 10;
  isAllDisplayDataChecked = false;
  isIndeterminate = false;
  mapOfCheckedId: { [key: string]: boolean } = {};
  listAgent: any = [];
  imageFalse: any[] = [];
  constructor(private fb: FormBuilder,
              private modalService: NzModalService,
              private notificationService: NzNotificationService,
              private rootService: RootService,
              private agentService: AgentService) { }
  ngOnInit(): void {
    this.initForm();
    this.loadCities();
    this.loadData();

    this.formAgent.get('keyword').valueChanges.pipe(debounceTime(500)).subscribe(val => {
      this.page = 1;
      this.loadData();
    });
    this.formAgent.get('provinceId').valueChanges.pipe(debounceTime(500)).subscribe(val => {
      this.page = 1;
      this.loadData();
    });
    this.formAgent.get('status').valueChanges.pipe(debounceTime(500)).subscribe(val => {
      this.page = 1;
      this.loadData();
    });
    this.formAgent.get('date').valueChanges.pipe(debounceTime(500)).subscribe(val => {
      this.page = 1;
      this.loadData();
    });
  }

  initForm() {
    this.formAgent = this.fb.group({
      keyword: null,
      provinceId: null,
      status: null,
      date: null
    });
  }

  resetData() {
    this.page = 1;
    this.formAgent.reset('', { emitEvent: false });
    this.loadData();
  }

  loadCities() {
    this.rootService.listCities().subscribe(
      (res: any) => {
        this.cities = res.data.items;
      },
      (err) => {
      },
    );
  }

  loadData() {
    // const params = this.formAgent.value;
    // params.fromDate = params && params.date && params.date.length ? getDateHelper(params.date[0]) : null;
    // params.toDate = params && params.date && params.date.length ? getDateHelper(params.date[1]) : null;
    // removeEmptyQuery(params);
    this.agentService.getAgency(this.getQueryParam()).subscribe(res => {
      this.loading = false;
      this.total = res.data.totalElement;
      this.listOfAllData = res.data.items;
      this.listAgent = _.uniqBy(this.listAgent.concat(...res.data.items), 'id');
    }, error => {
      this.loading = false;
    });
  }

  exportDataAgent() {
    this.agentService.getAgencyExport(this.getQueryParam()).subscribe(res => {
      this.rootService.export(res, 'Danh sách đại lý-ctv.xlsx');
    });

    // this.http.get<any>(`agency/export`)
  }

  getQueryParam() {
    const body = this.formAgent.value;
    body.fromDate = body && body.date && body.date.length ? getDateHelper(body.date[0], 'start') : null;
    body.toDate = body && body.date && body.date.length ? getDateHelper(body.date[1]) : null;
    body.page = this.page;
    body.pageSize = this.pageSize;
    body.keyword = body.keyword && body.keyword.length ?  body.keyword.trim() : '';
    return removeEmptyQuery(body);
  }

  currentPageDataChange($event: any[]): void {
    this.listOfDisplayData = $event;
    this.refreshStatus();
  }

  checkAll(value: boolean): void {
    this.listOfDisplayData.forEach(
      (item) => (this.mapOfCheckedId[item.id] = value)
    );
    // if (this.data1.length === this.listOfDisplayData.length) {
    //   this.data1 = [];
    //   this.isShow = true;
    //   return;
    // }
    // this.data1 = this.listOfDisplayData.map(data => {
    //   return {productName: data.productName ,  infoStatus: data.infoStatus,
    //     status: data.status, managementStatus: data.managementStatus, barcode: data.barcode};
    // });
    // console.log(this.data1);
    this.refreshStatus();
  }

  ids: any[] = [];
  refreshStatus(data?) {
    this.isAllDisplayDataChecked = this.listOfDisplayData.every(
      (item) => this.mapOfCheckedId[item.id]
    );
    this.isIndeterminate =
      this.listOfDisplayData.some(
        (item) => this.mapOfCheckedId[item.id]
      ) && !this.isAllDisplayDataChecked;
    this.ids = [];
    for (const [key, value] of Object.entries(this.mapOfCheckedId)) {
      if (value) {
        this.ids.push(key);
      }
    }

    console.log("this.ids", this.ids)
    // if (this.ids.length > 0) {
    //   this.isShow = false;
    // } else {
    //   this.isShow = true;
    // }
    //
    // if (data) {
    //   this.data = {productName: data.productName ,  infoStatus: data.infoStatus,
    //     status: data.status, managementStatus: data.managementStatus, barcode: data.barcode};
    //   const index = this.data1.findIndex(z => z.barcode === this.data.barcode);
    //   if (index === -1) {
    //     this.data1.push(this.data);
    //     console.log(this.data1);
    //     return;
    //   }
    //   this.data1.splice(index, 1);
    //   console.log(this.data1);
    //
    // }
  }

  showImage(id: any, imageLink: any) {
    if (!this.imageFalse.includes(id)) {
      window.open(imageLink, '_blank');
    }
  }

  checkImageErr(imageError: any) {
    this.imageFalse.push(imageError);
  }

  getProvince(provinceId) {
    if (provinceId) {
      const province = this.cities.filter( item => item.id === provinceId);
      return province.length ? province[0].name : '';
    }
    return '';
  }

  onRejectOrAccept(id, status, name?) {
    const modal = this.modalService.create({
      nzVisible: true,
      nzContent: PopupAcceptAgentComponent,
      nzClosable: false,
      nzWidth: 500,
      nzStyle: { top: '180px' },
      nzFooter: null,
      nzMaskClosable: true,
      nzComponentParams: {
        nameAgent: name,
        type: status == 1 ? 'accept' : 'reject'
      }
    });
    modal.afterClose.pipe().subscribe(val => {
      if (val && val.type === 'confirm') {
        // this.loadFormSetting();
        this.agentService.changeAgentStatus({
          ids: [id],
          status,
          reason: val.reason
        }).subscribe(res => {
          if (res.code === 1) {
            this.notificationService.success('Thông báo', status == 1 ? 'Phê duyệt thành công!' : 'Từ chối thành công!');
            this.loadData();
          } else {
            this.notificationService.error('Thông báo', res.message)
          }
        }, error => {
          this.notificationService.error('Thông báo', error)
        });
      }
    });
  }

  onAcceptReject(status) {
    if (this.ids && this.ids.length) {
      const newMyObj = {};
      // tslint:disable-next-line:prefer-for-of
      for (let i = 0; i < this.listAgent.length; i += 1) {
        newMyObj[this.listAgent[i].id] = this.listAgent[i].name;
      }
      const names = this.ids.map((id) => newMyObj[id]);
      const modal = this.modalService.create({
        nzVisible: true,
        nzContent: PopupAcceptAgentComponent,
        nzClosable: false,
        nzWidth: 500,
        nzStyle: { top: '180px' },
        nzFooter: null,
        nzMaskClosable: true,
        nzComponentParams: {
          nameAgent: names.join(', '),
          type: status == 1 ? 'accept' : 'reject'
        }
      });
      // tslint:disable-next-line:prefer-const
      modal.afterClose.pipe().subscribe(val => {
        if (val && val.type === 'confirm') {
          // this.loadFormSetting();
          this.agentService.changeAgentStatus({
            ids: this.ids,
            status,
            reason: val.reason
          }).subscribe(res => {
            if (res.code === 1) {
              this.notificationService.success('Thông báo', status == 1 ? 'Phê duyệt thành công!' : 'Từ chối thành công!');
              this.loadData();
            } else {
              this.notificationService.error('Thông báo', res.message)
            }
          }, error => {
            this.notificationService.error('Thông báo', error)
          });
        }
      });
    }

  }
}
